/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThreadWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACYElEQVR4nLWVu2sUURSHV3xAooI2ihGjnWIEQVR8ZgsNYuaexyzcOWdiQLFYEEH/BYmNjaudjdqJlVYKCoK1VsaAoLHTzoiFLzAG5czO7E7GXeOuuwMXZs7cOd/5ncedUqnDC0A3Esm2Uj+uIPCbkeUDkH5DjI73HIDodwLJD2T91RcIkWwBkncG6AsESWcy532BIOnjIuC/IWNjk6vD8NQmuy+XyyuA5BKyzvcMAqx3gGQBWGre+wGzOY4PAunbnkCA5Eyuc15DJTpsdkRcCyS3uoLYMAFr7L1flUQcRnuQZbruQBaA9GqmBlgqQDLXEQRIbtQ3y7Q5N5vBkHUqr4ZIDtXV6FCxAQwyXpnY2hwglhqAjthzEEa7kXU2jdgcTuXVAMvLFmqWIctFJPmevpuzTCTpsPFPyPYy1Au22Tk3iCzXzEkrNUByOesmUxOE0a40vSP5YEsmI8lZXh7Lo6w1HcdHkORNWzWkd4nicSt625wjRqPI8qUA+WSFTiMeQNYrQPqzrlRnEHVvR+1oVS8qSddN7/2aP9Xox2q1urIxgCz3kfSe9355N5BZCKMDCcS5QSsssp5tfBfq+Zzyc0spGQXSzy0g85amLOrsCoKJ9ck/gvW2LbsnOr3urxBHcgxZv7Y62Kzf83uB9LrZk5+RzUNdRW2JirSHAOmrxp5KvCMbPBdG+5jj/Y1uQ7+9G8h75/xwI3qWh02wPEPS57nnB0sCihCLzKJO7Cwn88rs2Ei6bJEtOtERJDnUUIfS6JPjIlvmnEiOFur14p8ACcT54TCc3NBMjz5t2QSL15PfB0/rhKC6iEkAAAAASUVORK5CYII=)
 */
export const ThreadWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12 2.81a1 1 0 0 1 0-1.41l.36-.36a1 1 0 0 1 1.41 0l9.2 9.2a1 1 0 0 1 0 1.4l-.7.7a1 1 0 0 1-1.3.13l-9.54-6.72a1 1 0 0 1-.08-1.58l1-1L12 2.8ZM12 21.2a1 1 0 0 1 0 1.41l-.35.35a1 1 0 0 1-1.41 0l-9.2-9.19a1 1 0 0 1 0-1.41l.7-.7a1 1 0 0 1 1.3-.12l9.54 6.72A1 1 0 0 1 13 19v.15a1 1 0 0 1-.35.69l-1 1 .35.36ZM14.66 16.32c.1-.39.26-.75.45-1.09l-8.2-5.47a1 1 0 1 0-1.12 1.66l8.13 5.42a3 3 0 0 1 .74-.52ZM16.43 13.8c.62-.43 1.36-.7 2.15-.78a1 1 0 0 0-.37-.43L9.73 6.93a1 1 0 0 0-1.11 1.66l7.81 5.21Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M18.09 15.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.92 1.92 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
